module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel05_770_280_ko-c47d66362d193d9d2964918d89a3f4c1.jpg";